import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformHostIntegrationAPIErrorCode {
  editorPlatformHostIntegrationUninitialized = 'editorPlatformHostIntegrationUninitialized',
}

export class EditorPlatformHostIntegrationAPIError extends BaseError<EditorPlatformHostIntegrationAPIErrorCode> {
  apiName?: string;

  constructor(
    message: string,
    code: EditorPlatformHostIntegrationAPIErrorCode,
  ) {
    super(message, code, 'Editor Platform Host Integration API Error');
  }

  withAPIName(apiName: string): this {
    this.apiName = apiName;
    return this;
  }
}

export const createEditorPlatformHostIntegrationAPIError = createErrorBuilder<
  EditorPlatformHostIntegrationAPIErrorCode,
  EditorPlatformHostIntegrationAPIError
>(EditorPlatformHostIntegrationAPIError);
